import { THEME_COLORS, MARKET_COLORS, STATUS_COLORS, INTERACTIVE_COLORS, SHADOWS, LIVE_COLORS } from './colors';
import { PAYMENT_METHODS } from './common';


/* --- From uodex.ts --- */
export const UODEX_COLORS = {
  ...THEME_COLORS,
  buy: MARKET_COLORS.buy,
  sell: MARKET_COLORS.sell,
  gold: MARKET_COLORS.partial,
  blue: MARKET_COLORS.open,
  inactive: MARKET_COLORS.cancelled,
} as const;

export const UODEX_PAIRS = ['ORB/AP', 'ORB/USDT'] as const;

export const UODEX_STATUS = {
  open: 'uodex.status.open',
  partial: 'uodex.status.partial',
  filled: 'uodex.status.filled',
  done: 'uodex.status.filled',
  cancelled: 'uodex.status.cancelled',
} as const;


/* --- From auction.ts --- */
export const AUCTION_COLORS = UODEX_COLORS;

export interface AuctionLotDef {
  id: number;
  titleKey: string;
  descriptionKey: string;
  assets: Array<{ token: string; amount: string; color: string }>;
  currentBid: string;
  minIncrement: string;
  bidCount: number;
  endsInMs: number;
  featured?: boolean;
}

export const AUCTION_LOTS: AuctionLotDef[] = [
  {
    id: 1001,
    titleKey: 'auction.lots.founder.title',
    descriptionKey: 'auction.lots.founder.desc',
    assets: [
      { token: 'ORB', amount: '10,000', color: '#79C0FF' },
      { token: 'EP1', amount: '5,000', color: '#F5EC63' },
      { token: 'EP2', amount: '5,000', color: '#4ACA61' },
      { token: 'SP1', amount: '2,000', color: '#F6A657' },
    ],
    currentBid: '28,500',
    minIncrement: '500',
    bidCount: 14,
    endsInMs: 2 * 3600_000 + 34 * 60_000,
    featured: true,
  },
  {
    id: 1002,
    titleKey: 'auction.lots.planet.title',
    descriptionKey: 'auction.lots.planet.desc',
    assets: [
      { token: 'ORB', amount: '3,000', color: '#79C0FF' },
      { token: 'RP', amount: '1,500', color: '#F74E5E' },
      { token: 'TP', amount: '1,500', color: '#D2A8FF' },
    ],
    currentBid: '8,200',
    minIncrement: '200',
    bidCount: 7,
    endsInMs: 5 * 3600_000 + 12 * 60_000,
  },
  {
    id: 1003,
    titleKey: 'auction.lots.earth.title',
    descriptionKey: 'auction.lots.earth.desc',
    assets: [
      { token: 'ORB', amount: '500', color: '#79C0FF' },
      { token: 'EP', amount: '200', color: '#F5EC63' },
      { token: 'FC', amount: '50', color: '#F74E5E' },
    ],
    currentBid: '1,100',
    minIncrement: '50',
    bidCount: 3,
    endsInMs: 11 * 3600_000 + 45 * 60_000,
  },
  {
    id: 1004,
    titleKey: 'auction.lots.uoc.title',
    descriptionKey: 'auction.lots.uoc.desc',
    assets: [
      { token: 'ORBC', amount: '2,000', color: '#79C0FF' },
      { token: 'MP', amount: '500', color: '#F6A657' },
      { token: 'RP', amount: '800', color: '#F74E5E' },
    ],
    currentBid: '5,600',
    minIncrement: '100',
    bidCount: 9,
    endsInMs: 18 * 3600_000,
  },
];

export const AUCTION_FILTERS = [
  { key: 'all', labelKey: 'common.all' },
  { key: 'ending', labelKey: 'auction.endingSoon' },
  { key: 'featured', labelKey: 'auction.featured' },
] as const;

/* --- From buyfuel.ts --- */
export const BUYFUEL_COLORS = UODEX_COLORS;

export const FUEL_PRESET_AMOUNTS = ['200', '500', '1000'];

export const FUEL_PAYMENT_METHODS = PAYMENT_METHODS;

/* --- From staking.ts --- */
export const STAKING_COLORS = UODEX_COLORS;

export interface StakePoolDef {
  id: string;
  token: string;
  labelKey: string;
  apy: string;
  lockDays: number;
  minAmount: string;
  totalStaked: string;
  color: string;
}

export const STAKING_POOLS: StakePoolDef[] = [
  { id: 'uo-flex', token: 'uo', labelKey: 'staking.pools.uoFlex', apy: '5.2', lockDays: 0, minAmount: '100', totalStaked: '1,250,000', color: '#79C0FF' },
  { id: 'uo-30', token: 'uo', labelKey: 'staking.pools.uo30', apy: '12.5', lockDays: 30, minAmount: '500', totalStaked: '3,800,000', color: '#79C0FF' },
  { id: 'uo-90', token: 'uo', labelKey: 'staking.pools.uo90', apy: '22.0', lockDays: 90, minAmount: '1000', totalStaked: '8,200,000', color: '#79C0FF' },
  { id: 'ep1-30', token: 'ep1', labelKey: 'staking.pools.ep1_30', apy: '18.0', lockDays: 30, minAmount: '200', totalStaked: '560,000', color: '#F5EC63' },
  { id: 'ep2-30', token: 'ep2', labelKey: 'staking.pools.ep2_30', apy: '18.0', lockDays: 30, minAmount: '200', totalStaked: '420,000', color: '#4ACA61' },
  { id: 'rp-flex', token: 'rp', labelKey: 'staking.pools.rpFlex', apy: '8.0', lockDays: 0, minAmount: '50', totalStaked: '2,100,000', color: '#F74E5E' },
];

export const STAKING_TABS = [
  { key: 'pools', labelKey: 'staking.tabs.pools' },
  { key: 'mine', labelKey: 'staking.tabs.mine' },
] as const;

/* --- From otc.ts --- */
export type OtcTabKey = 'hall' | 'book' | 'orders' | 'trades';


export const OTC_COLORS = {
  ...THEME_COLORS,
  buy: MARKET_COLORS.buy,
  sell: MARKET_COLORS.sell,
  blue: MARKET_COLORS.open,
  amber: MARKET_COLORS.partial,
  inactive: MARKET_COLORS.cancelled,
} as const;

export const OTC_TABS: Array<{ key: OtcTabKey; labelKey: string }> = [
  { key: 'hall', labelKey: 'otc.tabs.hall' },
  { key: 'book', labelKey: 'otc.tabs.book' },
  { key: 'orders', labelKey: 'otc.tabs.orders' },
  { key: 'trades', labelKey: 'otc.tabs.trades' },
];

export const OTC_STATUS = {
  open: { labelKey: 'otc.status.open', color: OTC_COLORS.blue },
  partial: { labelKey: 'otc.status.partial', color: OTC_COLORS.amber },
  done: { labelKey: 'otc.status.done', color: OTC_COLORS.buy },
  cancelled: { labelKey: 'otc.status.cancelled', color: OTC_COLORS.inactive },
} as const;

/* --- From trading.ts --- */
export type TradingTab = 'book' | 'mine' | 'chart';
export type TradingChartRange = '7d' | '30d' | '90d';




export const TRADING_CHART_RANGES: TradingChartRange[] = ['7d', '30d', '90d'];

export const TRADING_TABS: Array<{
  key: TradingTab;
  labelKey: string;
  icon: string;
  activeIcon: string;
}> = [
  { key: 'chart', labelKey: 'common.market', icon: '/brand/trading-tab-market.png', activeIcon: '/brand/trading-tab-market-a.png' },
  { key: 'book', labelKey: 'common.orderHall', icon: '/brand/trading-tab-book.png', activeIcon: '/brand/trading-tab-book-a.png' },
  { key: 'mine', labelKey: 'common.myOrders', icon: '/brand/trading-tab-mine.png', activeIcon: '/brand/trading-tab-mine-a.png' },
];

export const TRADING_COLORS = {
  ...THEME_COLORS,
  ...INTERACTIVE_COLORS,
  yellow: STATUS_COLORS.warning,
  green: STATUS_COLORS.success,
  red: STATUS_COLORS.error,
  blue: STATUS_COLORS.blue,
  black: '#000000',
  fixedTopBg: THEME_COLORS.topbarBg,
  tabActiveText: '#FFFFFF',
  tabInactiveText: STATUS_COLORS.inactive,
  rangeActiveBg: 'rgba(245,236,99,0.1)',
  epPriceShadow: SHADOWS.epPriceShadow,
  recentTimeText: INTERACTIVE_COLORS.recentTimeText,
} as const;

export const TRADING_LAYOUT = {
  fixedTopHeight: 134,
  contentTopSpacer: 132,
  tabTop: 65,
  tabPaddingTop: 27,
} as const;

export const TRADING_MARKET_FALLBACKS = {
  usdEstimate: '0.036',
  changePct: '+12.5%',
  orderBookMaxAmount: 8000,
  orderBookRows: 6,
  bidStartPrice: 0.248,
  askStartPrice: 0.252,
  priceStep: 0.002,
  amountStart: 900,
  amountStep: 640,
  recentRows: 6,
  recentTradeTimeStepMs: 47_000,
  recentBasePrice: 0.245,
  recentRiseStep: 0.004,
  recentFallStep: -0.003,
  recentAmountBase: 100,
  recentAmountRange: 2000,
} as const;

/* --- From ecosystem.ts --- */
export interface EcoProject {
  nameKey: string;
  descKey: string;
  route?: string;
  icon: string;
  iconSrc?: string;
  tagKey: string;
  live: boolean;
}

export type EcoStat = {
  value?: string;
  valueKey?: string;
  labelKey: string;
  tone?: 'gold' | 'green';
};


export const ECOSYSTEM_COLORS = {
  ...THEME_COLORS,
  ...SHADOWS,
  live: LIVE_COLORS.live,
  statGold: THEME_COLORS.statGoldGradient,
  statGreen: THEME_COLORS.statGreenGradient,
} as const;

export const ECO_PROJECTS: EcoProject[] = [
  { nameKey: 'ecosystem.projects.exchange.name', icon: '💰', iconSrc: '/brand/ecosystem-icons/exchange.png', descKey: 'ecosystem.projects.exchange.desc', route: '/wallet', tagKey: 'ecosystem.live', live: true },
  { nameKey: 'ecosystem.projects.p2p.name', icon: '💱', iconSrc: '/brand/ecosystem-icons/p2p.png', descKey: 'ecosystem.projects.p2p.desc', route: '/trading', tagKey: 'ecosystem.live', live: true },
  { nameKey: 'ecosystem.projects.dex.name', icon: '📊', iconSrc: '/brand/ecosystem-icons/dex.png', descKey: 'ecosystem.projects.dex.desc', route: '/dex', tagKey: 'ecosystem.live', live: true },
  { nameKey: 'ecosystem.projects.epMarket.name', icon: '✅', iconSrc: '/brand/ecosystem-icons/ep.png', descKey: 'ecosystem.projects.epMarket.desc', route: '/ep-hub', tagKey: 'ecosystem.live', live: true },
  { nameKey: 'ecosystem.projects.otc.name', icon: '🤝', iconSrc: '/brand/ecosystem-icons/otc.png', descKey: 'ecosystem.projects.otc.desc', route: '/otc', tagKey: 'ecosystem.live', live: true },
  { nameKey: 'ecosystem.projects.orbc.name', icon: '🔄', iconSrc: '/brand/ecosystem-icons/orbc.png', descKey: 'ecosystem.projects.orbc.desc', route: '/uoc', tagKey: 'ecosystem.live', live: true },
  { nameKey: 'ecosystem.projects.exchangeCalc.name', icon: '🧮', iconSrc: '/brand/ecosystem-icons/calculate.png', descKey: 'ecosystem.projects.exchangeCalc.desc', route: '/exchange-calc', tagKey: 'ecosystem.live', live: true },
];

export const ECO_STATS: EcoStat[] = [
  { value: '14', labelKey: 'ecosystem.stats.tokens' },
  { value: '8+', labelKey: 'ecosystem.stats.projects', tone: 'gold' },
  { valueKey: 'ecosystem.stats.activeValue', labelKey: 'ecosystem.stats.status', tone: 'green' },
];
